import React from "react";
import { Dropdown, Menu } from "antd";
import { Question } from "assets/icons";
import { IDataInformation } from "./dataInformations";
import * as S from "./styled/index.styled";

type IInformation = {
  informations: IDataInformation[];
};
const Informations = ({ informations }: IInformation): JSX.Element => {
  const data = () => (
    <Menu>
      <S.CardInformation>
        {informations.map((item) => (
          <div key={item.id}>
            <S.Title>{item.title}</S.Title>
            <S.Description>{item.description}</S.Description>
          </div>
        ))}
      </S.CardInformation>
    </Menu>
  );
  return (
    <div>
      <Dropdown overlay={data} placement="bottomLeft">
        <Question className="dataInformation" data-testid="dataInformation" />
      </Dropdown>
    </div>
  );
};

export default Informations;
